/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Worker
 */
export interface Worker {
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  campaignId: string;
  /**
   *
   * @type {number}
   * @memberof Worker
   */
  companyId: number;
  /**
   *
   * @type {number}
   * @memberof Worker
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Worker
   */
  dateExpiration?: number;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  dateExpirationIso?: string;
  /**
   *
   * @type {number}
   * @memberof Worker
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  id: string;
  /**
   *
   * @type {string | null}
   * @memberof Worker
   */
  itemId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  itemKey?: string;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  state?: string;
  /**
   *
   * @type {Array<any>}
   * @memberof Worker
   */
  tags?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Worker
   */
  workerId?: string;
}

/**
 * Check if a given object implements the Worker interface.
 */
export function instanceOfWorker(value: object): value is Worker {
  if (!('campaignId' in value) || value['campaignId'] === undefined)
    return false;
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function WorkerFromJSON(json: any): Worker {
  return WorkerFromJSONTyped(json, false);
}

export function WorkerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Worker {
  if (json == null) {
    return json;
  }
  return {
    campaignId: json['campaign_id'],
    companyId: json['company_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateExpiration:
      json['date_expiration'] == null ? undefined : json['date_expiration'],
    dateExpirationIso:
      json['date_expiration_iso'] == null
        ? undefined
        : json['date_expiration_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    id: json['id'],
    itemId: json['item_id'] == null ? undefined : json['item_id'],
    itemKey: json['item_key'] == null ? undefined : json['item_key'],
    key: json['key'],
    state: json['state'] == null ? undefined : json['state'],
    tags: json['tags'] == null ? undefined : json['tags'],
    workerId: json['worker_id'] == null ? undefined : json['worker_id'],
  };
}

export function WorkerToJSON(value?: Worker | null): any {
  if (value == null) {
    return value;
  }
  return {
    campaign_id: value['campaignId'],
    company_id: value['companyId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_expiration: value['dateExpiration'],
    date_expiration_iso: value['dateExpirationIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    id: value['id'],
    item_id: value['itemId'],
    item_key: value['itemKey'],
    key: value['key'],
    state: value['state'],
    tags: value['tags'],
    worker_id: value['workerId'],
  };
}
